(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5251],{

/***/ 84872:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E6": () => (/* binding */ SUPPORTED_LANGUAGE_PREFIXES),
/* harmony export */   "G3": () => (/* binding */ getLanguage),
/* harmony export */   "mn": () => (/* binding */ getHomeURL),
/* harmony export */   "oV": () => (/* binding */ getURLPrefix),
/* harmony export */   "vY": () => (/* binding */ getLanguageName),
/* harmony export */   "vw": () => (/* binding */ getLanguagePrefix)
/* harmony export */ });
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31955);

var SUPPORTED_LANGUAGE_PREFIXES = [
    "en",
    "pt",
    "es",
    "id",
    "zh"
];
/**
 * 获取语言
 * @param accepts 支持的语言
 * @returns 语言
 */ var getLanguage = function getLanguage(accepts) {
    var language = js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("DESIGN_CLIENT_LANGUAGE") || "en";
    if (!accepts || accepts.includes(language)) return language;
    // 如果支持的语言中没有当前语言，则返回默认语言
    return "en";
};
/**
 * 获取语言名称
 * @returns 语言名称
 */ var getLanguageName = function getLanguageName(languageCode) {
    var language = languageCode || getLanguage();
    switch(language){
        case "en":
            return "English";
        case "zh-Hans":
            return "简体中文";
        case "pt":
            return "Portugu\xeas（Brasil）";
        case "es":
            return "Espa\xf1ol（Mexico）";
        case "id":
            return "Bahasa Indonesia";
        case "de":
            return "Deutsch";
    }
};
/**
 * 获取语言对应的 URL 前缀
 */ var getLanguagePrefix = function getLanguagePrefix(language) {
    if (language === "en") {
        return "";
    }
    if (language === "zh-Hans") {
        return "zh";
    }
    return language;
};
/**
 * 获取首页URL
 * @param languageCode 语言代码
 * @returns 首页URL
 */ var getHomeURL = function getHomeURL(languageCode) {
    var language = languageCode || getLanguage();
    var prefix = getLanguagePrefix(language);
    return "/".concat(prefix);
};
/**
 * 获取路径多语言前缀，
 * @param languageCode 语言代码
 * @returns 多语言前缀，不用考虑前后/，直接拼接对应地址
 */ var getURLPrefix = function getURLPrefix(languageCode) {
    var language = languageCode || getLanguage();
    var prefix = getLanguagePrefix(language);
    if (!prefix) return "/";
    return "/".concat(prefix, "/");
};


/***/ }),

/***/ 41462:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ dist_logo)
});

// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/configProvider/index.js
var configProvider = __webpack_require__(97303);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/teamInfo/index.js
var teamInfo = __webpack_require__(46718);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/types/teamInfo.js
var types_teamInfo = __webpack_require__(32485);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-identity/lib/index.js
var lib = __webpack_require__(10275);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/i18n/index.js + 17 modules
var i18n = __webpack_require__(84704);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/logoGuide/constants/inedx.js
var lightLogo = "https://public.static.meitudata.com/xiuxiu-pc/xdesign-widgets/images/logo/logo-light.svg";
var darkLogo = "https://public.static.meitudata.com/xiuxiu-pc/xdesign-widgets/images/logo/logo-dark.svg";
var intlLogo = "https://x-design-static-release.stariicloud.com/xdesign-widgets/logo-light-intl.svg"; // export const intlDarkLogo =
 //   'https://x-design-static-release.stariicloud.com/xdesign-widgets/logo-dark-intl.svg';

// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/logoGuide/index.less
var logoGuide = __webpack_require__(44548);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/logoGuide/index.js
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}

//@ts-ignore




var LogoGuide = function LogoGuide(_ref) {
    var _ref$showTime = _ref.showTime, showTime = _ref$showTime === void 0 ? 5000 : _ref$showTime, _ref$showMaxAmount = _ref.showMaxAmount, showMaxAmount = _ref$showMaxAmount === void 0 ? 3 : _ref$showMaxAmount, homeLink = _ref.homeLink, _ref$showGuide = _ref.showGuide, showGuide = _ref$showGuide === void 0 ? true : _ref$showGuide, _ref$handleClick = _ref.handleClick, handleClick = _ref$handleClick === void 0 ? function() {} : _ref$handleClick, style = _ref.style, children = _ref.children;
    // const { showTime = 3000, showMaxAmount = 3 } = props;
    var _useConfig = (0,configProvider/* useConfig */.ZR)(), theme = _useConfig.theme, isIntl = _useConfig.isIntl, appName = _useConfig.appName;
    var _useState = (0,react.useState)(null), _useState2 = _slicedToArray(_useState, 2), showAmount = _useState2[0], setShowAmount = _useState2[1];
    var _useState3 = (0,react.useState)(false), _useState4 = _slicedToArray(_useState3, 2), showAnimation = _useState4[0], setShowAnimation = _useState4[1];
    var _useState5 = (0,react.useState)(false), _useState6 = _slicedToArray(_useState5, 2), imgLoaded = _useState6[0], setImgLoaded = _useState6[1];
    var timerIdRef = (0,react.useRef)(null);
    var _useLocale = (0,i18n/* useLocale */.bU)(), $t = _useLocale.$t;
    // 获取当前logo url
    var logoUrl = (0,react.useMemo)(function() {
        if (appName === "designkit") {
            return "https://xiuxiu-pro.meitudata.com/poster/34dee7a8298c7c00af88c236a9d6a438.svg";
        }
        if (isIntl) {
            return intlLogo;
        } else {
            return theme === "light" ? lightLogo : darkLogo;
        }
    }, [
        theme,
        isIntl
    ]);
    // 获取首页链接
    var homeUrl = (0,react.useMemo)(function() {
        if (homeLink === "") return null;
        return homeLink || window.location.origin;
    }, [
        homeLink
    ]);
    (0,react.useEffect)(function() {
        // 图片加载完再显示引导
        var image = new Image();
        image.onload = function() {
            setImgLoaded(true);
        };
        image.onerror = function() {};
        image.src = logoUrl;
    }, [
        logoUrl
    ]);
    var getShowAnimateAmount = function getShowAnimateAmount() {
        var num = localStorage.getItem("MT_LOGO_ANIMATION_AMOUNT");
        if (!num) {
            setShowAmount(0);
            localStorage.setItem("MT_LOGO_ANIMATION_AMOUNT", "0");
        } else {
            setShowAmount(Number(num));
        }
    };
    (0,react.useEffect)(function() {
        // 不需要引导 or 图片没加载完  or 海外版，直接退出
        if (!showGuide || !imgLoaded || isIntl) return;
        // 获取当前已显示的动画次数
        getShowAnimateAmount();
        // 超出最大显示次数，直接退出
        if (showAmount === null || showAmount >= showMaxAmount) return;
        setShowAnimation(true);
        timerIdRef.current = setTimeout(function() {
            var num = showAmount + 1;
            localStorage.setItem("MT_LOGO_ANIMATION_AMOUNT", String(num));
            setShowAnimation(false);
        }, showTime);
        // 在组件卸载时清除定时器
        return function() {
            timerIdRef.current && clearTimeout(timerIdRef.current);
        };
    }, [
        showAmount,
        showMaxAmount,
        showGuide,
        imgLoaded,
        isIntl
    ]);
    var onClick = function onClick() {
        if (homeUrl) {
            window.location.href = homeUrl;
        }
        handleClick && handleClick();
    };
    return /*#__PURE__*/ react.createElement("div", {
        onClick: onClick,
        className: "xdesign-logo",
        style: _objectSpread({}, style)
    }, children, showAnimation ? /*#__PURE__*/ react.createElement("div", {
        className: "xdesign-logo-guide"
    }, /*#__PURE__*/ react.createElement("svg", {
        className: "arrow",
        width: "44",
        height: "6",
        viewBox: "0 0 44 6",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ react.createElement("path", {
        d: "M8 6H20L15.4142 1.41421C14.6332 0.633165 13.3668 0.633166 12.5858 1.41421L8 6Z",
        fill: "#1E79FA"
    })), /*#__PURE__*/ react.createElement("svg", {
        className: "icon",
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ react.createElement("path", {
        d: "M10.3527 0.937816C10.4534 0.665748 10.8382 0.665747 10.9389 0.937816L11.1369 1.47293C11.2002 1.64401 11.3351 1.77889 11.5062 1.84219L12.0413 2.0402C12.3134 2.14088 12.3134 2.52569 12.0413 2.62636L11.5062 2.82437C11.3351 2.88768 11.2002 3.02256 11.1369 3.19363L10.9389 3.72875C10.8382 4.00082 10.4534 4.00082 10.3527 3.72875L10.1547 3.19363C10.0914 3.02256 9.95655 2.88768 9.78548 2.82437L9.25036 2.62636C8.97829 2.52569 8.97829 2.14088 9.25036 2.0402L9.78548 1.84219C9.95655 1.77889 10.0914 1.64401 10.1547 1.47293L10.3527 0.937816Z",
        fill: "white"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M3.37065 1.48617C2.59049 1.09724 1.71323 1.80203 1.92493 2.64768L4.30219 12.1436C4.53212 13.062 5.78003 13.1998 6.20479 12.3536L7.97192 8.83351L11.8359 7.67942C12.7228 7.41452 12.8276 6.20067 11.9992 5.78769L3.37065 1.48617Z",
        fill: "white"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M1.69279 8.50861C1.61225 8.29095 1.3044 8.29095 1.22386 8.50861L1.06545 8.9367C1.01481 9.07356 0.906905 9.18147 0.770046 9.23211L0.341952 9.39052C0.124297 9.47106 0.124297 9.7789 0.341952 9.85944L0.770046 10.0179C0.906905 10.0685 1.01481 10.1764 1.06545 10.3133L1.22386 10.7414C1.3044 10.959 1.61225 10.959 1.69279 10.7414L1.8512 10.3133C1.90184 10.1764 2.00975 10.0685 2.14661 10.0179L2.5747 9.85944C2.79235 9.7789 2.79235 9.47106 2.5747 9.39052L2.14661 9.23211C2.00975 9.18147 1.90184 9.07356 1.8512 8.9367L1.69279 8.50861Z",
        fill: "white"
    })), /*#__PURE__*/ react.createElement("span", null, $t(function(v) {
        return v.logo.homeTip;
    }))) : null);
};
/* harmony default export */ const dist_logoGuide = (/*#__PURE__*/(0,react.memo)(LogoGuide));

// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/languageSelectorPopup/utils.js
var utils = __webpack_require__(84872);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/logo/index.less
var logo = __webpack_require__(57250);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/logo/index.js










/**
 * header logo
 */ var Logo = function Logo(props) {
    var _getLocalIdentity;
    var logoUrl = props.logoUrl, customLogoContent = props.customLogoContent, height = props.height, width = props.width, sloganStyle = props.sloganStyle, hideSlogan = props.hideSlogan, hideName = props.hideName, hideLogo = props.hideLogo, hideCollectTip = props.hideCollectTip, _props$slogan = props.slogan, slogan = _props$slogan === void 0 ? "电商人必备的AI设计工具" : _props$slogan, subTitle = props.subTitle, subTitleStyle = props.subTitleStyle, showAIIcon = props.showAIIcon, _props$showGuide = props.showGuide, showGuide = _props$showGuide === void 0 ? false : _props$showGuide, _props$showLogoIcon = props.showLogoIcon, showLogoIcon = _props$showLogoIcon === void 0 ? true : _props$showLogoIcon, _props$target = props.target, target = _props$target === void 0 ? "_blank" : _props$target, showTime = props.showTime, showMaxAmount = props.showMaxAmount, onClick = props.onClick, onSubTitleClick = props.onSubTitleClick, _props$url = props.url, url = _props$url === void 0 ? "/" : _props$url;
    var currentIdentity = (0,teamInfo/* useCurrentTeamIdentity */.q5)();
    var hasFetchTeamInfo = (0,teamInfo/* useHasFetchTeamInfoState */.Yr)();
    var _useConfig = (0,configProvider/* useConfig */.ZR)(), theme = _useConfig.theme, isIntl = _useConfig.isIntl, isTeam = _useConfig.isTeam, appName = _useConfig.appName;
    var _useLocale = (0,i18n/* useLocale */.bU)(), $t = _useLocale.$t;
    var getImagURL = function getImagURL() {
        // 国内设计室logo
        if (!isIntl) {
            return theme === "dark" ? "https://public.static.meitudata.com/xiuxiu-pc/xdesign-widgets/images/logo/logo-dark.png" : "https://public.static.meitudata.com/xiuxiu-pc/xdesign-widgets/images/logo/logo-light.png";
        }
        // 全球化设计室logo
        if (appName === "designkit") {
            return "https://xiuxiu-pro.meitudata.com/poster/34dee7a8298c7c00af88c236a9d6a438.svg";
        }
        // X-Design logo
        if (showLogoIcon) {
            return "https://x-design-static-release.stariicloud.com/xdesign-widgets/logo-icon.svg";
        }
        return theme === "dark" ? "https://x-design-static-release.stariicloud.com/xdesign-widgets/logo-dark.svg" : "https://x-design-static-release.stariicloud.com/xdesign-widgets/logo-light.svg";
    };
    var aiIcon = isIntl ? "https://x-design-static-release.stariicloud.com/poster/eb0ff9e04863d6c243b10ae4d9cb0dbf.svg" : "https://public.static.meitudata.com/xiuxiu-pc/xdesign-widgets/images/logo/AI.svg";
    // 个人版，直接展示logo
    // 非个人版，要等团队信息回来后再决定展示啥logo
    if (isTeam && (_getLocalIdentity = (0,lib/* getLocalIdentity */.u5)()) !== null && _getLocalIdentity !== void 0 && _getLocalIdentity.oid && !hasFetchTeamInfo) return null;
    var handleSubtTitleClick = function handleSubtTitleClick() {
        if ((onSubTitleClick === null || onSubTitleClick === void 0 ? void 0 : onSubTitleClick()) === false) return;
        window.open(window.location.href);
    };
    return /*#__PURE__*/ react.createElement("div", {
        className: classnames_default()("xdesign-logo-module", {
            "xdesign-logo-module--intl": isIntl
        })
    }, !hideLogo ? /*#__PURE__*/ react.createElement(dist_logoGuide, {
        showGuide: showGuide,
        homeLink: "",
        showMaxAmount: showMaxAmount,
        showTime: showTime,
        handleClick: function handleClick() {
            if ((onClick === null || onClick === void 0 ? void 0 : onClick()) === false) return;
            var homeURL = isIntl && appName === "designkit" ? (0,utils/* getHomeURL */.mn)() : "/";
            target === "_self" ? window.location.href = homeURL : window.open(homeURL);
        }
    }, /*#__PURE__*/ react.createElement("div", {
        className: "xdesign-logo-module__container"
    }, (currentIdentity === null || currentIdentity === void 0 ? void 0 : currentIdentity.type) !== types_teamInfo/* IdentityType.ENTERPRISE */.Mf.ENTERPRISE ? /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement("a", {
        href: url,
        onClick: function onClick(e) {
            return e.preventDefault();
        },
        className: "xdesign-logo-module__img--row"
    }, /*#__PURE__*/ react.createElement("img", {
        className: "xdesign-logo-module__img",
        style: {
            height: height,
            width: width
        },
        src: logoUrl || getImagURL(),
        alt: hideCollectTip ? "" : isIntl ? appName === "designkit" ? "Designkit" : "x-design.com" : "美图设计室"
    }), customLogoContent ? /*#__PURE__*/ react.createElement("div", {
        className: "xdesign-logo-module__replace-content"
    }, customLogoContent) : null, !hideCollectTip && !isIntl ? /*#__PURE__*/ react.createElement("div", {
        className: "xdesign-logo-module__tooltip"
    }, $t(function(v) {
        return v.logo.toolTip;
    })) : null), !hideSlogan ? /*#__PURE__*/ react.createElement("div", {
        className: "xdesign-logo-module__slogan",
        style: sloganStyle,
        onClick: function onClick(e) {
            return e.stopPropagation();
        }
    }, slogan) : null) : /*#__PURE__*/ react.createElement("div", {
        className: "xdesign-logo-module__img--row"
    }, /*#__PURE__*/ react.createElement("img", {
        className: "xdesign-logo-module__img--team",
        style: {
            height: height,
            width: height
        },
        src: currentIdentity === null || currentIdentity === void 0 ? void 0 : currentIdentity.logo,
        alt: ""
    }), !hideName ? /*#__PURE__*/ react.createElement("div", {
        className: "xdesign-logo-module__name",
        style: sloganStyle
    }, currentIdentity === null || currentIdentity === void 0 ? void 0 : currentIdentity.name) : null))) : null, subTitle ? /*#__PURE__*/ react.createElement(react.Fragment, null, !hideLogo ? /*#__PURE__*/ react.createElement("div", {
        className: "xdesign-logo-module__line"
    }) : null, /*#__PURE__*/ react.createElement("div", {
        className: "xdesign-logo-module__subTitle",
        onClick: handleSubtTitleClick,
        style: subTitleStyle
    }, showAIIcon ? /*#__PURE__*/ react.createElement("img", {
        src: aiIcon,
        alt: "ai",
        className: "xdesign-logo-module__aiIcon"
    }) : null, subTitle)) : null);
};
/* harmony default export */ const dist_logo = (/*#__PURE__*/react.memo(Logo));


/***/ }),

/***/ 71409:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ dist_navVipEntrance)
});

// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/i18n/index.js + 17 modules
var i18n = __webpack_require__(84704);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/types/navVipEntrance.js
var SceneEnum = /*#__PURE__*/ function(SceneEnum) {
    SceneEnum["BUTTON"] = "button";
    SceneEnum["ENTRANCE"] = "entrance";
    return SceneEnum;
}({});

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/configProvider/index.js
var configProvider = __webpack_require__(97303);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/xdesign-icon-font/dist/IconFont.js + 2 modules
var IconFont = __webpack_require__(74107);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/navVipEntrance/images/brickwork-icon.png
/* harmony default export */ const brickwork_icon = ({"src":"https://pc.meitudata.com/live-ppt/_next/static/media/brickwork-icon.4ba650ba.png","height":32,"width":33,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAyklEQVR42h3LrW4CURDF8f/tbhGVbWUbUlNXU09dk8oqFBheglfA8wQEh8MgwIHAEIJBIFB8SRSbXXZnlhPE5M7c3zkBwNMDnPY1rHjCcseLwENlCqQxAMddG/eOANzA9ObpEPiPfDtvUXpXzY3mFbui4BrPaxTZR4zbmw7UGghWwItCme6erBoAfD3uCxuCieCsva7ZkCXfMQDQFH5i9isAyy/a/4gqSfDVMAJMgWe1l8Iqpf0AM0L0GAB8MYiBgmvyBeU7MBLe/27wDXUiI3MiAwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/navVipEntrance/components/navVipBtn/index.less
var navVipBtn = __webpack_require__(73111);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/navVipEntrance/components/navVipBtn/index.js





var NavVipEntrance = function NavVipEntrance(props) {
    var data = props.data, style = props.style, onClick = props.onClick;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, data && data.vip_top_content ? /*#__PURE__*/ react.createElement("div", {
        onClick: onClick,
        className: classnames_default()("xdesign-nav-vip-btn"),
        style: style
    }, /*#__PURE__*/ react.createElement("img", {
        className: "xdesign-nav-vip-btn__icon",
        src: typeof brickwork_icon === "string" ? brickwork_icon : brickwork_icon.src
    }), /*#__PURE__*/ react.createElement("div", {
        className: "xdesign-nav-vip-btn__text"
    }, data.vip_top_content), /*#__PURE__*/ react.createElement(IconFont/* default */.Z, {
        name: "ChevronRightBlack",
        fontSize: 12
    })) : null);
};
/* harmony default export */ const components_navVipBtn = (NavVipEntrance);

// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/utils/request.js
var request = __webpack_require__(57526);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/navVipEntrance/services/index.js

var getVipList = function getVipList(params, abInfo) {
    var headers = {};
    if (abInfo) {
        headers["ab_info"] = JSON.stringify(abInfo);
    }
    return request/* default.get */.ZP.get("/v1/home/get_init_data", {
        params: params,
        headers: headers
    });
};

// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/types/userInfo.js
var types_userInfo = __webpack_require__(8209);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/navVipEntrance/index.less
var navVipEntrance = __webpack_require__(41284);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/navVipEntrance/index.js
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
function _regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    _regeneratorRuntime = function _regeneratorRuntime() {
        return exports;
    };
    var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        return Object.defineProperty(obj, key, {
            value: value,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), obj[key];
    }
    try {
        define({}, "");
    } catch (err) {
        define = function define(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []);
        return defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        }), generator;
    }
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if ("throw" !== record.type) {
                var result = record.arg, value = result.value;
                return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                }) : PromiseImpl.resolve(value).then(function(unwrapped) {
                    result.value = unwrapped, resolve(result);
                }, function(error) {
                    return invoke("throw", error, resolve, reject);
                });
            }
            reject(record.arg);
        }
        var previousPromise;
        defineProperty(this, "_invoke", {
            value: function value(method, arg) {
                function callInvokeWithMethodAndArg() {
                    return new PromiseImpl(function(resolve, reject) {
                        invoke(method, arg, resolve, reject);
                    });
                }
                return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(innerFn, self, context) {
        var state = "suspendedStart";
        return function(method, arg) {
            if ("executing" === state) throw new Error("Generator is already running");
            if ("completed" === state) {
                if ("throw" === method) throw arg;
                return doneResult();
            }
            for(context.method = method, context.arg = arg;;){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if ("next" === context.method) context.sent = context._sent = context.arg;
                else if ("throw" === context.method) {
                    if ("suspendedStart" === state) throw state = "completed", context.arg;
                    context.dispatchException(context.arg);
                } else "return" === context.method && context.abrupt("return", context.arg);
                state = "executing";
                var record = tryCatch(innerFn, self, context);
                if ("normal" === record.type) {
                    if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                }
                "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
            }
        };
    }
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method, method = delegate.iterator[methodName];
        if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
        var record = tryCatch(method, delegate.iterator, context.arg);
        if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
        var info = record.arg;
        return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if ("function" == typeof iterable.next) return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    for(; ++i < iterable.length;)if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
                    return next.value = undefined, next.done = !0, next;
                };
                return next.next = next;
            }
        }
        return {
            next: doneResult
        };
    }
    function doneResult() {
        return {
            value: undefined,
            done: !0
        };
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function(genFun) {
        var ctor = "function" == typeof genFun && genFun.constructor;
        return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function(genFun) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
    }, exports.awrap = function(arg) {
        return {
            __await: arg
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        void 0 === PromiseImpl && (PromiseImpl = Promise);
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
        return this;
    }), define(Gp, "toString", function() {
        return "[object Generator]";
    }), exports.keys = function(val) {
        var object = Object(val), keys = [];
        for(var key in object)keys.push(key);
        return keys.reverse(), function next() {
            for(; keys.length;){
                var key = keys.pop();
                if (key in object) return next.value = key, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, exports.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(skipTempReset) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for(var name in this)"t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
        },
        stop: function stop() {
            this.done = !0;
            var rootRecord = this.tryEntries[0].completion;
            if ("throw" === rootRecord.type) throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i], record = entry.completion;
                if ("root" === entry.tryLoc) return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                    } else {
                        if (!hasFinally) throw new Error("try statement without catch or finally");
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
            var record = finallyEntry ? finallyEntry.completion : {};
            return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
        },
        complete: function complete(record, afterLoc) {
            if ("throw" === record.type) throw record.arg;
            return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
        },
        finish: function finish(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
            }
        },
        catch: function _catch(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if ("throw" === record.type) {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(iterable, resultName, nextLoc) {
            return this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
        }
    }, exports;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}









var instance = null;
// 顶导文案接口返回的当前用户uid的值
var currentUid = undefined;
var dataCache = undefined;
var navVipEntrance_NavVipEntrance = function NavVipEntrance(_ref) {
    var _ref$uid = _ref.uid, uid = _ref$uid === void 0 ? 0 : _ref$uid, _ref$topDis = _ref.topDis, topDis = _ref$topDis === void 0 ? 20 : _ref$topDis, _ref$userInfo = _ref.userInfo, userInfo = _ref$userInfo === void 0 ? undefined : _ref$userInfo, requestParams = _ref.requestParams, _ref$scene = _ref.scene, scene = _ref$scene === void 0 ? SceneEnum.ENTRANCE : _ref$scene, customBtnText = _ref.customBtnText, style = _ref.style, handleClick = _ref.handleClick, track = _ref.track, abInfo = _ref.abInfo;
    var _useConfig = (0,configProvider/* useConfig */.ZR)(), theme = _useConfig.theme, isIntl = _useConfig.isIntl, appName = _useConfig.appName;
    var _useState = (0,react.useState)(dataCache), _useState2 = _slicedToArray(_useState, 2), data = _useState2[0], setData = _useState2[1];
    var isFirstRef = (0,react.useRef)(true);
    var _useLocaleStore = (0,i18n/* useLocaleStore */.Ee)(), $t = _useLocaleStore.$t;
    var fetchData = /*#__PURE__*/ function() {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee() {
            var _yield$import, clientInfo, bridge, params, res, _data;
            return _regeneratorRuntime().wrap(function _callee$(_context) {
                while(1)switch(_context.prev = _context.next){
                    case 0:
                        _context.prev = 0;
                        _context.next = 3;
                        return __webpack_require__.e(/* import() */ 1022).then(__webpack_require__.t.bind(__webpack_require__, 21022, 23));
                    case 3:
                        _yield$import = _context.sent;
                        clientInfo = _yield$import.clientInfo;
                        bridge = _yield$import.bridge;
                        params = _objectSpread({}, requestParams); // 区分顶导入口的来源，web/pc/mac/linux
                        if (clientInfo.isPC) {
                            params.source = "MTXX-PC";
                        } else if (clientInfo.isLinux) {
                            params.source = "MTXX-LINUX";
                        } else if (clientInfo.isMac) {
                            params.source = "MTXX-MAC";
                        } else if (clientInfo.isWeb) {
                            params.source = "MTXX-WEB";
                        }
                        // 区分是否属于iap支付(appstore商店支付)
                        if (clientInfo.isMacAppStore) {
                            params.iap = 1;
                        } else {
                            params.iap = 0;
                        }
                        _context.prev = 9;
                        if (!clientInfo.isClient) {
                            _context.next = 15;
                            break;
                        }
                        _context.next = 13;
                        return bridge.getSystemInfo();
                    case 13:
                        res = _context.sent;
                        if ((res === null || res === void 0 ? void 0 : res.channel) === "lx10000") {
                            params.channel = "lx10000";
                        } else if (clientInfo.isMacAppStore) {
                            params.channel = "appstore";
                        }
                    case 15:
                        _context.next = 19;
                        break;
                    case 17:
                        _context.prev = 17;
                        _context.t0 = _context["catch"](9);
                    case 19:
                        _context.next = 21;
                        return getVipList(params, abInfo);
                    case 21:
                        _data = _context.sent;
                        return _context.abrupt("return", _data);
                    case 25:
                        _context.prev = 25;
                        _context.t1 = _context["catch"](0);
                        ;
                        return _context.abrupt("return", false);
                    case 29:
                    case "end":
                        return _context.stop();
                }
            }, _callee, null, [
                [
                    0,
                    25
                ],
                [
                    9,
                    17
                ]
            ]);
        }));
        return function fetchData() {
            return _ref2.apply(this, arguments);
        };
    }();
    /**
   * 用户信息接口和团队信息接口并发请求
   * 如果用户信息接口先返回，则有uid，会重新再次触发团队信息接口，这时需要等第一次团队信息接口响应返回后再决定，如果有值则取消请求
   * @param userId
   */ var handleFetchData = /*#__PURE__*/ function() {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee2(userId) {
            var _data2, _ref4;
            return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                while(1)switch(_context2.prev = _context2.next){
                    case 0:
                        if (!(userId && currentUid === userId)) {
                            _context2.next = 2;
                            break;
                        }
                        return _context2.abrupt("return");
                    case 2:
                        _context2.prev = 2;
                        if (!instance) {
                            _context2.next = 9;
                            break;
                        }
                        _context2.next = 6;
                        return instance;
                    case 6:
                        _context2.t0 = _context2.sent;
                        _context2.next = 12;
                        break;
                    case 9:
                        _context2.next = 11;
                        return instance = fetchData();
                    case 11:
                        _context2.t0 = _context2.sent;
                    case 12:
                        _data2 = _context2.t0;
                        if (_data2) {
                            dataCache = _data2;
                            setData(_data2);
                            if (_data2.vip_top_content && scene === SceneEnum.ENTRANCE) {
                                // 显示顶导
                                (_ref4 = track || window._stat_track) === null || _ref4 === void 0 ? void 0 : _ref4("topnav_show", {});
                            }
                            currentUid = _data2.uid;
                        } else {
                            fetchData();
                        }
                        instance = null;
                    case 15:
                        _context2.prev = 15;
                        instance = null;
                        return _context2.finish(15);
                    case 18:
                    case "end":
                        return _context2.stop();
                }
            }, _callee2, null, [
                [
                    2,
                    ,
                    15,
                    18
                ]
            ]);
        }));
        return function handleFetchData(_x2) {
            return _ref3.apply(this, arguments);
        };
    }();
    /**
   * 按钮文案，海外单独处理
   */ var subscriptionBtnTxt = (0,react.useMemo)(function() {
        if (isIntl) {
            if (appName === "designkit") {
                if (userInfo !== null && userInfo !== void 0 && userInfo.id) {
                    if (userInfo !== null && userInfo !== void 0 && userInfo.is_vip) {
                        if (userInfo !== null && userInfo !== void 0 && userInfo.has_trial) {
                            return userInfo.vip_level === types_userInfo/* VipLevel.Basic */.Dv.Basic ? $t(function(v) {
                                return v.Button_Pro;
                            }) : "";
                        } else {
                            return userInfo.vip_level === types_userInfo/* VipLevel.Basic */.Dv.Basic ? $t(function(v) {
                                return v.Button_UpgradeToPro;
                            }) : $t(function(v) {
                                return v.Button_RenewNow;
                            });
                        }
                    } else {
                        return userInfo !== null && userInfo !== void 0 && userInfo.has_trial ? $t(function(v) {
                            return v.Button_Pro;
                        }) : $t(function(v) {
                            return v.Button_UnlockPro;
                        });
                    }
                }
            } else {
                if (userInfo !== null && userInfo !== void 0 && userInfo.id) {
                    if (!(userInfo !== null && userInfo !== void 0 && userInfo.is_vip)) {
                        return userInfo !== null && userInfo !== void 0 && userInfo.has_trial ? $t(function(v) {
                            return v.navVipEntrance.upgradeForFree;
                        }) : $t(function(v) {
                            return v.userInfo.upgradeNow;
                        });
                    } else if (!(userInfo !== null && userInfo !== void 0 && userInfo.is_subscribe)) {
                        return $t(function(v) {
                            return v.navVipEntrance.renewNow;
                        });
                    }
                } else {
                    return $t(function(v) {
                        return v.navVipEntrance.upgradeForFree;
                    });
                }
            }
            return $t(function(v) {
                return v.Button_Pro;
            });
        }
        return (data === null || data === void 0 ? void 0 : data.vip_top_content) || "";
    }, [
        isIntl,
        userInfo === null || userInfo === void 0 ? void 0 : userInfo.is_vip,
        userInfo === null || userInfo === void 0 ? void 0 : userInfo.is_subscribe,
        userInfo === null || userInfo === void 0 ? void 0 : userInfo.has_trial,
        data === null || data === void 0 ? void 0 : data.vip_top_content
    ]);
    (0,react.useEffect)(function() {
        // 业务是否透传abInfo字段，如果有透传需要等待
        var hasAbProp = typeof abInfo !== "undefined";
        // case1：业务没传 abInfo → 立即请求
        // 海外没有ab测试
        if (!hasAbProp || isIntl) {
            // 非页面第一次加载且退出登录操作时uid=0，此时不需要重新调用接口
            if (!uid && !isFirstRef.current) return;
            handleFetchData(uid);
            isFirstRef.current = false;
            return;
        }
        // case2：业务传了 abInfo → 需要等待 abInfo 或超时
        var timer;
        if (abInfo) {
            // abInfo 已有值 → 立即触发
            // 非页面第一次加载且退出登录操作时uid=0，此时不需要重新调用接口
            if (!uid && !isFirstRef.current) return;
            handleFetchData(uid);
            isFirstRef.current = false;
        } else {
            // abInfo 没有值 → 开启 2 秒兜底
            timer = setTimeout(function() {
                if (!uid && !isFirstRef.current) return;
                handleFetchData(uid);
                isFirstRef.current = false;
            }, 2000);
        }
        return function() {
            clearTimeout(timer);
        };
    }, [
        uid,
        abInfo,
        isIntl
    ]);
    if (isIntl) {
        if (appName === "designkit") {
            // DesignKit
            // @link https://cf.meitu.com/confluence/pages/viewpage.action?pageId=638007102
            if ((userInfo === null || userInfo === void 0 ? void 0 : userInfo.vip_level) === types_userInfo/* VipLevel.Pro */.Dv.Pro && (userInfo !== null && userInfo !== void 0 && userInfo.is_subscribe || userInfo !== null && userInfo !== void 0 && userInfo.has_trial)) return null;
        } else if (userInfo !== null && userInfo !== void 0 && userInfo.is_subscribe && userInfo !== null && userInfo !== void 0 && userInfo.is_vip) {
            // XD 会员且续约才不展示
            // @link https://cf.meitu.com/confluence/pages/viewpage.action?pageId=545426460
            return null;
        }
    }
    // 国内，生成按钮场景下的会员引导入口
    if (!isIntl && scene === SceneEnum.BUTTON) {
        return /*#__PURE__*/ react.createElement(components_navVipBtn, {
            data: data,
            style: style,
            onClick: handleClick
        });
    }
    return /*#__PURE__*/ react.createElement(react.Fragment, null, data && data.vip_top_content ? /*#__PURE__*/ react.createElement("div", {
        onClick: function onClick() {
            var _ref5;
            (_ref5 = track || window._stat_track) === null || _ref5 === void 0 ? void 0 : _ref5("topnav_click", {});
            handleClick && handleClick();
        },
        className: classnames_default()("xdesign-nav-vip-entrance", {
            "xdesign-nav-vip-entrance--intl": isIntl && appName === "x-design"
        }),
        onMouseEnter: function onMouseEnter() {
            var _ref6;
            (_ref6 = track || window._stat_track) === null || _ref6 === void 0 ? void 0 : _ref6("top_dropdowns_show", {
                class: "topnav"
            });
        },
        style: style
    }, /*#__PURE__*/ react.createElement("div", {
        className: classnames_default()("xdesign-nav-vip-entrance__btn", {
            "xdesign-nav-vip-entrance__btn--dark": theme === "dark"
        })
    }, /*#__PURE__*/ react.createElement("div", {
        className: "xdesign-nav-vip-entrance__icon"
    }), /*#__PURE__*/ react.createElement("div", {
        className: "xdesign-nav-vip-entrance__text"
    }, customBtnText || subscriptionBtnTxt))) : null);
};
/* harmony default export */ const dist_navVipEntrance = (navVipEntrance_NavVipEntrance);


/***/ }),

/***/ 8209:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dv": () => (/* binding */ VipLevel),
/* harmony export */   "FW": () => (/* binding */ UserType),
/* harmony export */   "dE": () => (/* binding */ ListKeyType)
/* harmony export */ });
/* unused harmony export BalanceListKeyType */
/**
 * 用户信息数据类型
 *
 * @see https://api-mock.meitu-int.com/project/2110/interface/api/116813
 */ var VipLevel = /*#__PURE__*/ function(VipLevel) {
    VipLevel[VipLevel["Basic"] = 1] = "Basic";
    VipLevel[VipLevel["Pro"] = 2] = "Pro";
    return VipLevel;
}({});
var ListKeyType = /*#__PURE__*/ function(ListKeyType) {
    ListKeyType["FEEDBACK"] = "feedBack";
    ListKeyType["BUSINESS"] = "business";
    ListKeyType["DOWNLOAD"] = "download";
    ListKeyType["CREDIT"] = "credit";
    ListKeyType["ManageSubscriptions"] = "manageSubscriptions";
    ListKeyType["Subscription"] = "subscription";
    ListKeyType["TermsPolicies"] = "terms-policies";
    ListKeyType["Compensation"] = "compensation";
    ListKeyType["Language"] = "language";
    ListKeyType["Redeem"] = "redeem";
    ListKeyType["Invite"] = "invite";
    return ListKeyType;
}({});
var BalanceListKeyType = /*#__PURE__*/ function(BalanceListKeyType) {
    BalanceListKeyType["MEIDOU"] = "meidou";
    BalanceListKeyType["CUTOUT"] = "cutout";
    return BalanceListKeyType;
}({});
/**
 * 用户信息组件属性
 */ /**
 * 用户类型
 */ var UserType = /*#__PURE__*/ function(UserType) {
    UserType["PERSONAL"] = "personal";
    UserType["TEAM"] = "team";
    UserType["COMPANY"] = "company";
    return UserType;
}({});


/***/ }),

/***/ 57250:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 44548:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 73111:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 41284:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ })

}]);